import { apiClient } from './client';
import type { UserScheduleEntry } from '../types/api';

export const userScheduleApi = {
  async getSchedule(): Promise<UserScheduleEntry[]> {
    return apiClient.get<UserScheduleEntry[]>('/v1/users/schedule');
  },

  async saveSchedule(entries: UserScheduleEntry[]): Promise<UserScheduleEntry[]> {
    return apiClient.put<UserScheduleEntry[]>('/v1/users/schedule', entries);
  },
};
